module.exports = __webpack_public_path__ + "static/img/popup_20260728.5019c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/popup_20260728.jpg
// module id = VXsj
// module chunks = 1